export default __webpack_public_path__ + "static/media/tomato-logo.078dd896.svg";